import React from "react";
import "./testimonials.css";
import AVTR1 from "../../assets/avatar1.jpg";
import AVTR2 from "../../assets/avatar2.jpg";
import AVTR3 from "../../assets/avatar3.jpg";
import AVTR4 from "../../assets/avatar4.jpg";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";

import { Pagination } from "swiper/modules";

const Testimonials = () => {
  const reviewData = [
    {
      name: "Pragya",
      image: AVTR1,
      reviewMsg:
        "Working with Pranav has been a game-changer for our business. Their expertise in UI/UX development has helped us create a visually stunning and highly intuitive website that has significantly improved our customer engagement and conversion rates. Their attention to detail and ability to translate our design vision into a functional reality is truly impressive.",
    },
    {
      name: "Aman",
      image: AVTR2,
      reviewMsg:
        "As a full-stack web development professional, Pranav has consistently delivered exceptional results. They have a deep understanding of both front-end and back-end technologies, allowing them to craft seamless and scalable web applications. Their collaborative approach and problem-solving skills have been instrumental in the success of our projects.",
    },
    {
      name: "Nihal",
      image: AVTR3,
      reviewMsg:
        "I had the pleasure of working with Pranav on a complex DevOps project, and I was thoroughly impressed by their expertise. They were able to streamline our deployment process, optimize our cloud infrastructure, and implement robust monitoring and security measures. Their ability to navigate the ever-evolving DevOps landscape and deliver tangible improvements to our operations has been invaluable.",
    },
    {
      name: "Jimmy",
      image: AVTR4,
      reviewMsg:
        "Pranav is a professional who has a versatile skill set, which spans UI/UX design, full-stack development, and DevOps, has made them an invaluable asset to our team. Their commitment to quality, their attention to detail, and their ability to adapt to changing requirements have been instrumental in the success of our projects. I highly recommend [Your Name] to anyone looking for a reliable and talented web development partner.",
    },
  ];
  const pagination = {
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + "</span>";
    },
  };

  return (
    <section id="testimonials">
      <h5>What People Have To Say About Me</h5>
      <h2>Testimonials</h2>

      <Swiper
        pagination={pagination}
        modules={[Pagination]}
        className="container testimonials_container"
      >
        {reviewData.map(({ name, image, reviewMsg }, index) => {
          return (
            <SwiperSlide key={index} className="testimonials">
              <div className="avatar">
                <img src={image} alt="User" />
              </div>
              <h5>{name}</h5>
              <small className="review">{reviewMsg}</small>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
};

export default Testimonials;
